interface ProcessStepsSolution {
  number: number;
  title: string;
  description: string;
  headlineText?: string;
}

interface ProcessStepsSolutionProps {
  steps?: ProcessStepsSolution[];
  image?: string;
  imageAlt?: string;
  title?: string;
  headlineText?: string;
}

export const ProcessStepsSolution = ({
  steps = [
    {
      number: 1,
      title: 'Simplify. Optimize. Automate',
      description:
        'Ligula risus auctor tempus feugiat dolor lacinia nemo purus in lipsum purus sapien quaerat a primis viverra tellus vitae luctus dolor ipsum neque ligula quaerat'
    },
    {
      number: 2,
      title: 'Enhanced Security Features',
      description:
        'Ligula risus auctor tempus feugiat dolor lacinia nemo purus in lipsum purus sapien quaerat a primis viverra tellus vitae luctus dolor ipsum neque ligula quaerat'
    },
    {
      number: 3,
      title: 'No Personal Data Collected',
      description:
        'Ligula risus auctor tempus feugiat dolor lacinia nemo purus in lipsum purus sapien quaerat a primis viverra tellus vitae luctus dolor ipsum neque ligula quaerat'
    }
  ],
  image = '/images/tablet-01.png',
  imageAlt = 'content-image'
}: ProcessStepsSolutionProps) => {
  return (
    <section id="results-steps" className="ct-04 content-section division">
      <div className="container">
        {/* TITLE */}
        <h2 className="s-56 w--700 xl:!text-[3.5rem] md:max-lg:!text-[2.94117rem] lg:max-xl:!text-[3.25rem] sm:max-md:!text-[2.375rem] xsm:max-sm:!text-[2.0625rem] !text-black !font-bold leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35] xl:!mb-[35px] lg:max-xl:!mb-[25px] md:max-lg:!mb-[20px] md:max-lg:px-[3%] md:max-lg:py-0 sm:max-md:!mb-[20px] xsm:max-sm:!mb-[18px]">
          ✅ The Solution, powered by BrokerMax
        </h2>
        {/* SECTION CONTENT (ROW) */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] items-center">
          {/* TEXT BLOCK */}
          <div className="md:w-6/12 lg:max-xl:w-6/12 xl:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full order-last order-md-2 md:max-lg:order-2 lg:max-xl:order-2 xl:order-2">
            <div className="txt-block left-column wow fadeInRight">
              {steps.map((step, index) => {
                const isLast = index === steps.length - 1;
                return (
                  <div
                    key={step.number}
                    className="cbox-2 process-step flex relative items-stretch justify-start [flex-flow:row_wrap] group"
                  >
                    {/* Icon */}
                    <div className="ico-wrap relative mr-[1.625rem] lg:max-xl:mr-[1.1rem] md:max-lg:mr-[1.15rem] xsm:max-sm:mr-4">
                      <div className="cbox-2-ico color--white relative xl:!w-[2.625rem] xl:!h-[2.625rem] !text-center xl:!text-[1.1875rem] font-medium leading-[2.375rem] [transition:all_450ms_ease-in-out] rounded-[100%] [border:2px_solid_transparent] lg:max-xl:!w-[2.35rem] lg:max-xl:!h-[2.35rem] lg:max-xl:!text-[1.135rem] lg:max-xl:leading-8 md:max-lg:!w-[2.15rem] md:max-lg:!h-[2.15rem] md:max-lg:!text-[1.125rem] md:max-lg:!leading-[1.85rem] xsm:max-sm:!w-[2.3rem] xsm:max-sm:!h-[2.3rem] xsm:max-sm:!text-[1.15rem] xsm:max-sm:!leading-[2.05rem] group-hover:!bg-transparent group-hover:scale-110">
                        {/* {step.number} */}✅
                      </div>
                      {!isLast && (
                        <span className="cbox-2-line !absolute !w-[2px] bg-[#e4e4e4] xl:!h-[calc(100%_-_90px)] -translate-x-2/4 left-2/4 bottom-5 lg:max-xl:!h-[calc(100%_-_74px)] md:max-lg:!h-[calc(100%_-_74px)] xsm:max-sm:!h-[calc(100%_-_74px)]"></span>
                      )}
                    </div>
                    {/* Text */}
                    <div className="cbox-2-txt overflow-hidden flex-1 max-w-full mb-[35px] lg:max-xl:!mb-[25px] md:max-lg:!mb-[20px] xsm:max-sm:!mb-[25px]">
                      <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4] xl:!mb-[15px] lg:max-xl:!mb-[12px] md:max-lg:!mb-[10px] sm:max-md:!mb-[12px] xsm:max-sm:!mb-[12px] !font-bold">
                        {step.title}
                      </h5>
                      <p className="!leading-[1.6666] !mb-0" data-nosnippet>
                        {step.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {/* END TEXT BLOCK */}
          {/* IMAGE BLOCK */}
          <div className="md:w-6/12 lg:max-xl:w-6/12 xl:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full order-first order-md-2 md:max-lg:order-2 lg:max-xl:order-2 xl:order-2">
            <div className="img-block !text-center wow fadeInLeft ml-[30px] lg:max-xl:ml-[15px] md:max-lg:ml-[15px]">
              <img
                className="img-fluid max-w-none inline-block lg:max-xl:!max-w-[175%] md:max-lg:!max-w-[220%]"
                src={image}
                alt={imageAlt}
              />
            </div>
          </div>
        </div>
        {/* END SECTION CONTENT (ROW) */}
      </div>
      {/* End container */}
    </section>
  );
};
